import React from 'react';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import VisibilityIcon from '@mui/icons-material/Visibility';

import AutoCompleteInput from 'screens/components/basic/AutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "AggregateInventoryLevel";

const Header = ({ showBody, download }) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-12 col-lg-6 col-xl-6">
                <AutoCompleteInput
                    name={`${componentName}ProductId`}
                    label="Search an existing product"
                    hintText="Product"
                    className={"AutoCompleteInput-searchbar"}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-lg-6 col-xl-6 d-flex align-items-center justify-content-end">
                <Button
                    type="IconInButton"
                    className="pull-right mr-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={download}
                />
            </div>
        </div>
    </CardSimple>
);

export default Header;
